import styled from 'styled-components';

export const StyledResultsDataLink = styled.a`
    color: ${({ isactive }) => (isactive ? '#fff' : '#333')};
    cursor: pointer;
    font-family: 'FilsonProRegular';
`;
